import { render, staticRenderFns } from "./DriverListWrapper.vue?vue&type=template&id=2fc66e66"
import script from "./DriverListWrapper.vue?vue&type=script&lang=js"
export * from "./DriverListWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports